export default {
  'customer.router.name': 'Customer',
  'customer.title': 'Customer management',
  'customer.update': 'Update customer',
  'customer.name': 'First and last name',
  'customer.nickName': 'Nick name',
  'customer.customerName': 'Customer name',
  'customer.phoneNumber': 'Phone number',
  'customer.fullName': 'First and last name',
  'customer.address': 'Address',
  'customer.province': 'Province/city',
  'customer.district': 'District',
  'customer.ward': 'Wards',
  'customer.status': 'Operating status',
  'customer.info': 'Customer information',

  'ItemWarehouse.tab.name': 'Warehouse',
  'VouchersWarehouse.tab.name': 'Voucher warehouse conversion',
  'GiftWarehouse.tab.name': 'Gift warehouse',
  'ScoreHistory.tab.name': 'History of points',
  'RankHistory.tab.name': 'Ranking history',

  'customer.validate-phone': 'Invalid phone number',

  'customer.greenCoin': 'Green coin </br> (remaining/total accumulation)',
  'customer.greenCoin.xlsx': 'Green coin (remaining/total accumulation)',
  'customer.greenCoin.used': 'Green coin used',

  'customer.lastWeekRanking': 'Ranked last month',
  'customer.specificAddress': 'Address',
  'customer.currentWeekRanking': 'Ranking of the current month',
  'customer.overallRanking': 'Overall ranking',
  'customer.action': 'Act',
  'customer.status.param': '{status,select, 1 {Active} 2 {Stop operation} other {Unknown}}',
  'customer.accumulatedCoins': 'The accumulated coin number',
  'customer.remainingCoins': 'Number of coins used',

  'scoreHistory.device.specificAddress': 'Installation address',
  'scoreHistory.device.name': 'Device',
  'scoreHistory.time': 'Time',
  'scoreHistory.invalidQuantity': 'The number of other brand bottles',
  'scoreHistory.validQuantity': 'The number of bottles is Aqua',
  'scoreHistory.score': 'Number of points achieved',
  'scoreHistory.card.score': 'The total number of points achieved',
  'scoreHistory.card.invalidQuantity': 'The total number of other brand bottles',
  'scoreHistory.card.validQuantity': 'Total number of bottles Aqua',

  'giftWarehouse.status.type': '{status,select, 1 {Artifact} 2 {Voucher} other {unknown}}',
  'giftWarehouse.status.source':
    '{status,select, 1 {Source of Awards} 2 {Source of ranking} other {Unknown}}',
  'giftWarehouse.total-gift': 'Total number of gifts',
  'giftWarehouse.rank-gift': 'Ranking gifts',
  'giftWarehouse.different-gift': 'Other gifts',

  'giftWarehouse.awardName': 'Prize',
  'giftWarehouse.rank': 'Rank',
  'giftWarehouse.code': 'Gift code',
  'giftWarehouse.name': 'Gift name',
  'giftWarehouse.type': 'Gift type',
  'giftWarehouse.coin': 'Green coin number',
  'giftWarehouse.sourceGift': 'Gift source',
  'giftWarehouse.createdAt': 'Time',
  'giftWarehouse.giftRevokingStatus': 'Gift status',
  'giftWarehouse.status.giftRevokingStatus':
    '{status,select, 1 {Revoke} 2 {Gifts distributed} other {Unknown}}',
  'giftWarehouse.action': 'Act',
  'giftWarehouse.type-artifact': 'Artifacts',
  'giftWarehouse.type-voucher': 'voucher',
  'giftWarehouse.source-awardSource': 'Admin awarded',
  'giftWarehouse.source-rankSource': 'Weekly rankings',
  'giftWarehouse.source-Item-offers': 'Preferential items',
  'giftWarehouse.information': 'Gift information',

  'customers.createdAt.time': 'Time',

  'itemWarehouse.action': 'Act',
  'itemWarehouse.item.thumbnail': 'Image',
  'itemWarehouse.item.code': 'Item code',
  'itemWarehouse.item.name': 'Name of the item',
  'itemWarehouse.item.group.name': 'Item group',
  'itemWarehouse.item.quantity': 'greenCoin',
  'itemWarehouse.item.collection.name': 'Collection',
  'itemWarehouse.item.type': 'Type of item',
  'itemWarehouse.equippingStatus': 'Status',
  'itemWarehouse.createdAt': 'Buy time',
  'itemWarehouse.status.type': '{status,select, 1 {The normal type} 2 {Mystery} other {Unknown}}',
  'itemWarehouse.status.equippingStatus':
    '{status,select, 1 {Equipped} 2 {Not equipped} 3 {Recovered} other {Unknown}}',
  'itemWarehouse.status.normal': 'The normal type',
  'itemWarehouse.status.mystery': 'Mystery',
  'itemWarehouse.status.equipping': 'Equipped',
  'itemWarehouse.status.notEquipping': 'Not equipped',
  'itemWarehouse.status.revoked': 'Recovered',
  'itemWarehouse.card.itemQuantity': 'Total number of items',
  'itemWarehouse.card.coinQuantity': 'The total number of green coins bought items',
  'itemWarehouse.information': 'Message information',
  'customer.title.recall': 'Revoke items',
  'customer.content.recall': 'Are you sure you want to recover this item?',
  'customer.title.gift-recall': 'Gift recovery',
  'customer.content.gift-recall': 'Are you sure you want to recover this gift?',

  'vouchersWarehouse.price': 'Convert point (Green Coin)',
  'vouchersWarehouse.name': 'Voucher type',
  'vouchersWarehouse.receivingTime': 'Receiving time',
  'vouchersWarehouse.usageStatus': 'Status use',
  'vouchersWarehouse.totalVoucher': 'Total voucher',
  'vouchersWarehouse.totalGreencoin': 'The total number of conversion points',

  'vouchersWarehouse.used': 'Used',
  'vouchersWarehouse.unUsed': 'Unused',
  'vouchersWarehouse.normal': 'Normal',
  'vouchersWarehouse.prioritize': 'Priority',
  'vouchersWarehouse.information': 'Information warehouse voucher',
  'Green.Coin': 'Green Coin',
  'vouchersWarehouse.amountCoin': 'The amount/points received',
  'vouchersWarehouse.phoneNumber': 'Phone number received',

  'rankHistory.numberWeeksRanked': 'The total number of weeks has been ranked',
  'rankHistory.awardWinningRatings': 'Number of prizes',
  'rankHistory.title.closingTime': 'Time',
  'rankHistory.rank': 'Rank',
  'rankHistory.awardName': 'Prize',
  'rankHistory.coin': 'Number of Green Coin',
  'rankHistory.month.id': 'Month',
  'rankHistory.closingTime': 'Bonus time',
  'customer.avatarPicture': 'AVT',
  'customer.userName': 'User name',
  'customer.createdAt': 'Date created',

  'customer.usedCoins': 'Coins used',
};
